var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 9.81641C7.74696 9.81641 8.46332 9.51968 8.9915 8.9915C9.51968 8.46332 9.81641 7.74696 9.81641 7C9.81641 6.25304 9.51968 5.53668 8.9915 5.0085C8.46332 4.48032 7.74696 4.18359 7 4.18359C6.25304 4.18359 5.53668 4.48032 5.0085 5.0085C4.48032 5.53668 4.18359 6.25304 4.18359 7C4.18359 7.74696 4.48032 8.46332 5.0085 8.9915C5.53668 9.51968 6.25304 9.81641 7 9.81641Z",
    stroke: "#999999",
    strokeWidth: 1.09683,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.663086 9.81641V4.18359C0.663086 3.2499 1.034 2.35444 1.69422 1.69422C2.35444 1.034 3.2499 0.663086 4.18359 0.663086H9.81641C10.7501 0.663086 11.6456 1.034 12.3058 1.69422C12.966 2.35444 13.3369 3.2499 13.3369 4.18359V9.81641C13.3369 10.7501 12.966 11.6456 12.3058 12.3058C11.6456 12.966 10.7501 13.3369 9.81641 13.3369H4.18359C3.2499 13.3369 2.35444 12.966 1.69422 12.3058C1.034 11.6456 0.663086 10.7501 0.663086 9.81641Z",
    stroke: "#999999",
    strokeWidth: 1.09683
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8721 3.13468L10.8791 3.12695",
    stroke: "#999999",
    strokeWidth: 1.09683,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnInstagram);
export default __webpack_public_path__ + "static/media/icn_instagram.0e7494663c85740ab7318eb428fe3107.svg";
export { ForwardRef as ReactComponent };